import React, { useEffect, useState, useMemo, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { map } from 'lodash';

import useTheme from '@kufox/mui/hooks/useTheme';
import { styled } from '@kufox/mui/emotion';
import Input from '@kufox/mui/Input';

const Container = styled.div`
  position: relative;
  z-index: 1;
`;

const DropdownMenu = styled.ul`
  position: absolute;
  margin: 4px 0 0;
  padding: 0;
  width: 100%;
  max-height: 202px;
  overflow-y: auto;
  background: ${(props) => props.theme.colors.backgroundMajor};
  border: 1px solid ${(props) => props.theme.colors.cover4};
  box-shadow: 0px 0px 1px rgba(0, 0, 0, 0.1), 0px 4px 8px rgba(0, 0, 0, 0.05);
  border-radius: 4px;
`;

const DeopdownMenuItem = styled.li`
  width: 100%;
  padding: 9px 12px;
  line-height: 22px;
  list-style: none;
  font-size: ${(props) => props.theme.fonts.size.lg.fontSize};
  color: ${(props) => props.theme.colors.text20};
  cursor: pointer;
  word-wrap: break-word;
  &:hover {
    background-color: ${(props) => props.theme.colors.cover4};
  }
`;

const SuffixText = styled.span`
  color: ${(props) => props.theme.colors.text};
`;

const AssociativeEmailInput = (props) => {
  const { namespace, onInput, onBlur, onChange } = props;
  const theme = useTheme();
  const dispatch = useDispatch();
  const inputRef = useRef(null);
  const [inputValue, setInputValue] = useState('');
  const [showDropdown, setShowDropdown] = useState(false);
  const { emailSuffixes } = useSelector((state) => state[namespace]);
  const seperatorIndex = inputValue.indexOf('@'); // 分隔符索引
  const seperatorPos = seperatorIndex > -1 ? seperatorIndex : inputValue.length;
  const prefix = inputValue.slice(0, seperatorPos); // 前缀部分

  // 针对当前输入匹配后缀
  const matchedSuffixes = useMemo(() => {
    if (seperatorIndex === -1) return emailSuffixes;
    const _suffix = inputValue.slice(seperatorIndex + 1);
    return emailSuffixes.filter((item) => {
      if (item.startsWith(_suffix)) return item;
    });
  }, [seperatorIndex, emailSuffixes, inputValue]);

  // 是否有匹配的后缀：没有时不弹出下拉框
  const hasMatchedSuffix = (v) => {
    if (typeof v === 'string') {
      if (v === '') return false;
      const _index = v.indexOf('@');
      if (_index === -1) return true;
      const inputSuffix = v.slice(_index + 1);
      return emailSuffixes.some((item) => item.startsWith(inputSuffix));
    }
    return false;
  };

  const handleInput = (e) => {
    const _value = e.target.value;
    setInputValue(_value);
    setShowDropdown(hasMatchedSuffix(_value));
    typeof onInput === 'function' && onInput(_value);
  };

  const handleChoose = (suffix) => {
    const _full = `${prefix}@${suffix}`;
    setShowDropdown(false);
    typeof onChange === 'function' && onChange(_full);
  };

  const handleBlur = () => {
    typeof onBlur === 'function' && onBlur();
    setShowDropdown(false);
  };

  useEffect(() => {
    dispatch({ type: `${namespace}/getEmailSuffixes` });
    return () => {};
  }, []);

  return (
    <Container>
      <Input {...props} onInput={handleInput} onBlur={handleBlur} ref={inputRef} />
      {showDropdown ? (
        <DropdownMenu theme={theme}>
          {map(matchedSuffixes, (item) => (
            <DeopdownMenuItem key={item} theme={theme} onMouseDown={() => handleChoose(item)}>
              {prefix}
              <SuffixText theme={theme}>{`@${item}`}</SuffixText>
            </DeopdownMenuItem>
          ))}
        </DropdownMenu>
      ) : null}
    </Container>
  );
};

export default AssociativeEmailInput;
